import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";

const getUrl = (): string => {
  return `/channel`
};


function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },

    create: (data: RequestData) => {
      return HttpRequest.post(getUrl(), data.payload, {});
    },

    update: (data: RequestData) => {
      const {params = {}, payload} = data;
      return HttpRequest.post(`${getUrl()}/${params.id}`, payload, {});
    },

    delete: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.delete(`${getUrl()}/${params.id}`, {});
    },

    getItem: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/${params.id}`);
    },
  };
}

export default api();
